import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";


@Component({
  selector: 'app-custome-lineitem',
  templateUrl: './custome-lineitem.component.html',
  styleUrls: ['./custome-lineitem.component.css']
})
export class CustomeLineitemComponent implements OnInit {
  customeLineItemForm: FormGroup;
  public activeClass: string;
  @Input() id: any;
  @Output() toggleForm = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService) {

    this.customeLineItemForm = this.fb.group({
      item: [null, Validators.required],
      price: [null, Validators.required],
      description: [null]
    })
  }

  ngOnInit() {
    if (this.id) {
      this.getCustomeLineItems(this.id);

    }
  }

  getCustomeLineItems = function (id) {
    this.ppOptions = {};
    this.CommonService.apiService(
      "GET",
      "custom/line/item/" + id,
      this.ppOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.customeLineItemForm.setValue({
              'item': response.data.item,
              'price': response.data.price,
              'description': response.data.description

            });

          }

        }
        this.activeClass='active';
      },
      err => {
        console.log(err);
      }
    );
  }

  saveCustomeLineItem = function (postData) {
    if (this.customeLineItemForm.valid) {
      this.loading = true;
      const formData = new FormData();

      formData.append('item', postData.item);
      formData.append('description', postData.description);
      formData.append('price', postData.price);
      let apiName: string;    
      if (!this.id) {
        formData.append('id', localStorage.getItem("userID"));
        apiName = "custom/line/item/create";
      }
      else {
        formData.append('id', this.id);
        apiName = "custom/line/item/edit";
      }

      this.CommonService.apiService(
        "POST",
        apiName,
        formData
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            this.customeLineItemForm.reset();
            this.backToList();
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });

          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    } else {
      this.validateAllFormFields(this.customeLineItemForm);
    }
  };

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  backToList(): void {
    this.toggleForm.emit();
  }

  isFieldValid(field: string) {
    return (
      !this.customeLineItemForm.get(field).valid &&
      this.customeLineItemForm.get(field).touched
    );
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/custome-lineitem/custome-lineitem.component.ts